import { all, put, call, takeEvery } from 'redux-saga/effects';
import { push } from 'react-router-redux';

import { PRODUCTS } from '../../constants';

import { changeProduct } from '@xanadu/ui-shared/modules/application/actions';

import {
  REQUEST_PROMO_PAGE,
  setPromoPage,
} from './actions';

import * as api from './api';

function* callRequestPromoPage({ payload: { promoUrl } }) {
  const result = yield call(api.requestPromoPage, promoUrl);

  if (result.error === 'promo-not-available') {
    yield put(push('/promotions'));
    return;
  }

  if (result.id) {
    const productExists = Object.values(PRODUCTS).includes(result.product);
    const cmsSafeProduct = productExists ? result.product : PRODUCTS.exchange;

    yield put(changeProduct(cmsSafeProduct));
    yield put(setPromoPage(result));
  }
}

export default function* root() {
  yield all([
    takeEvery(REQUEST_PROMO_PAGE, callRequestPromoPage),
  ]);
}
